import create from "zustand";
import {PathDoesNotExistError} from "./Errors";


const reservedPrefix = '__'


export interface File {
    name: string;
    content: string;
}

export interface Directory {
    __files: File[];

    [key: string]: Directory | File[];
}

class DirectoryTest {
    __files: File[];

    constructor(files: File[]) {
        this.__files = files;
    }
}



const directories: Directory = {
    __files: [],
    home: {
        __files: [],
        k4: {
            __files: [
                {
                    name: 'test.txt',
                    content: 'Hello World'
                },
                {
                    name: 'test2.txt',
                    content: 'Hello World 2'
                },
            ]
        }
    }
}

export interface DirectoryState {
    activePath: string[];
    setActivePath: (path: string) => void;
    getActiveDirectory: () => Directory;
}

const parsePath = (pathStr: string): string[] => {
    let absPath: string[] = [];
    let path = pathStr.split('/');
    for (let i = 0; i < path.length; i++) {
        if (i === 0 && path[i] === '~') {
            absPath.push('home');
            path = path.slice(i + 1);
            i = 0;
        } else if (i === 0 && (path[i] === '' || path[i] === '.')) {
            absPath.push(...DirectoryStore.getState().activePath);
        } else if (path[i] === '..') {
            absPath.pop();
        } else {
            absPath.push(path[i]);
        }
    }
    return absPath;
}

const checkIfExists = (pathStr: string) => {
    // return {exists: boolean, isFile: boolean}
    let absPath = parsePath(pathStr);
    let activeDirectory = directories;
    for (let i = 0; i < absPath.length; i++) {
        // if last element check file exists for this directory
        if (i === absPath.length - 1) {
            if (activeDirectory.__files__) {
                for (let j = 0; j < activeDirectory.__files.length; j++) {
                    if (activeDirectory.__files[j].name === absPath[i]) {
                        return {exists: true, isFile: true};
                    }
                }
            }
            // if not file check if directory exists
            if (activeDirectory[absPath[i]]) {
                return {exists: true, isFile: false};
            }
            return {exists: false, isFile: false};
        }
        // if not last element check if directory exists and its not a file
        if (activeDirectory[absPath[i]]) {
            activeDirectory = activeDirectory[absPath[i]] as Directory;
        }
    }
    return {exists: false, isFile: false}; // TODO: check if this is correct
}

export const DirectoryStore = create<DirectoryState>((set) => ({
    activePath: [],
    setActivePath: (path) => set((state) => {
        let absPath = parsePath(path);
        if (checkIfExists(path).exists) {
            return {activePath: absPath};
        }
        throw new PathDoesNotExistError(`Path ${path} does not exist`);
    }),
    getActiveDirectory: () => {
        let activeDirectory = directories;
        for (let i = 0; i < DirectoryStore.getState().activePath.length; i++) {
            if (activeDirectory[DirectoryStore.getState().activePath[i]]) {
                activeDirectory = activeDirectory[DirectoryStore.getState().activePath[i]] as Directory;
            }
        }
        return activeDirectory;
    }
}));


